import { router } from '@inertiajs/vue3'

export default {
  mounted(el, binding) {
    const options = normalizeBinding(binding)

    // Store the timeout ID for the prefetch
    el.__prefetchTimeout__ = null;

    const startListener = () => {
      // Clear any existing timeout to restart the "debounce"
      if (el.__prefetchTimeout__) {
        clearTimeout(el.__prefetchTimeout__);
      }

      // Set a new timeout for the prefetch to occur after 2 seconds
      el.__prefetchTimeout__ = setTimeout(() => {
        const href = el.getAttribute('href');
        if (href) {
          router.prefetch(href, { method: 'get' }, { cacheFor: options.cacheFor || '2m' });
        }
        el.__prefetchTimeout__ = null; // Clear the timeout ID once executed
      }, 2000); // 2000 milliseconds = 2 seconds
    };

    const endListener = () => {
      // If the event ends before the timeout completes, clear the timeout
      if (el.__prefetchTimeout__) {
        clearTimeout(el.__prefetchTimeout__);
        el.__prefetchTimeout__ = null;
      }
    };

    // Attach both start and end listeners
    el.__startListener__ = startListener;
    el.__endListener__ = endListener;

    // Use 'mouseenter' for start and 'mouseleave' for end if the event is 'mouseenter'
    // Otherwise, you might need to reconsider the event handling for a custom event
    const startEvent = options.event;
    const endEvent = (options.event === 'mouseenter') ? 'mouseleave' : null; // For example, for 'focus', 'blur' could be used

    el.addEventListener(startEvent, startListener);
    if (endEvent) {
      el.addEventListener(endEvent, endListener);
    }
  },

  unmounted(el, binding) {
    const options = normalizeBinding(binding);

    // Clear any pending timeout when the element is unmounted
    if (el.__prefetchTimeout__) {
      clearTimeout(el.__prefetchTimeout__);
      delete el.__prefetchTimeout__;
    }

    // Remove event listeners
    if (el.__startListener__) {
      el.removeEventListener(options.event, el.__startListener__);
      delete el.__startListener__;
    }

    const endEvent = (options.event === 'mouseenter') ? 'mouseleave' : null;
    if (endEvent && el.__endListener__) {
      el.removeEventListener(endEvent, el.__endListener__);
      delete el.__endListener__;
    }
  }
}

// Utility function to handle different binding types
function normalizeBinding(binding) {
  if (typeof binding.value === 'string') {
    return { event: binding.value };
  }

  return {
    event: binding.value?.event || 'mouseenter',
    cacheFor: binding.value?.cacheFor || '2m'
  };
}
